
function isInvalidTokenError(error) {
  return error?.response?.data?.code === "INVALID_TOKEN" || error?.code === "INVALID_TOKEN";
}

function redirectToLogin() {
  const path = window.location.pathname.replace(/\/$/, "");

  if (path === "/auth" || path.startsWith("/auth/")) {
    return;
  }

  window.location.replace("/auth");
}

export function handleInvalidToken(context, error, options = {}) {
  if (!isInvalidTokenError(error)) {
    return false;
  }

  if (!options.shouldLogoutOnInvalidToken || options.shouldLogoutOnInvalidToken(error)) {
    context.commit("logout");
    redirectToLogin();
  }

  return true;
}

export function handleAsyncError(context, fn, options = {}) {
    return function (...args) {
      return fn(...args).catch((error) => {


        if (handleInvalidToken(context, error, options)) {
          return;
        }

        if (!Object.hasOwn(error, 'response')) {
        console.error('Unhandled Error:', error);
      }
        // Manually trigger the global error handler 
        /*
        if (this.$root && this.$root.$options.errorHandler) {
          this.$root.$options.errorHandler(error, this, fn.name);
        } else {
          console.error('Unhandled Error:', error);
        }*/

      });
    };
  }
